<template>
    <Head title="Mon profile" />

    <FrontLayout>
        <main>
            <ProfileUser link-updade-profile="front.profile.update" />
        </main>
    </FrontLayout>
</template>

<script>
    import { Head } from '@inertiajs/inertia-vue3';
    import FrontLayout from '@/Layouts/FrontLayout.vue'
    import ProfileUser from '@/Components/ProfileUser.vue'

    export default {
        components: {
            Head,
            FrontLayout,
            ProfileUser
        }
    }
</script>
